import Service from "./service";

const ModuleName = "tfApp.swift";

const dependencies = [
    Service(ModuleName)
];

export default angular.module(ModuleName, dependencies)
                      .name;
